// extracted by mini-css-extract-plugin
export default {"goBack":"BackButton_goBack__T5VAa","goBackIcon":"BackButton_goBackIcon__0RCoC"};